import {EntityType, HibobOffice, HibobOfficeForm} from "./Model";
import {arrayResource, EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {WorkSites_Read} from "../util/access/Permission";
import {idEqFn} from "../util/FunctionUtil";

interface HibobOfficeStore extends EntityStore<HibobOffice[]> {
    updateHibobOffice: (office: HibobOffice, form: HibobOfficeForm) => Promise<HibobOffice>;
}

export const useHibobOfficeStore = create<HibobOfficeStore>()(
    arrayResource<HibobOffice, HibobOfficeStore>(EntityType.WorkSites, builder => {
        const rest = builder.crud<HibobOfficeForm>('/hibob-offices', 'id');

        return {
            remoteValue: builder.all(WorkSites_Read, () => rest.getAll()),
            updateHibobOffice: builder.updateAndPatch(rest, undefined, idEqFn),
        };
    })
);

startEntityStore(useHibobOfficeStore);
